import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdPermContactCalendar } from 'react-icons/md';

const Phonebook: React.FC<IconBaseProps> = (props) => (
  <MdPermContactCalendar {...props} />
);

export default Phonebook;
